import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-scroll-container',
  templateUrl: './scroll-container.component.html',
  styleUrl: './scroll-container.component.scss'
})
export class ScrollContainerComponent implements AfterViewInit {
  @ViewChild('scrollArea') scrollArea!: ElementRef<HTMLDivElement>;

  atStart = true;
  atEnd = true;

  private intervalId: any = null;

  ngAfterViewInit() {
    this.onScroll();
  }

  onScroll() {
    const el = this.scrollArea.nativeElement;

    console.log('el.scrollLeft', el.scrollLeft);
    console.log('el.scrollLeft + el.clientWidth', el.scrollLeft + el.clientWidth);
    console.log('el.scrollWidth', el.scrollWidth);
    this.atStart = el.scrollLeft === 0;
    this.atEnd = el.scrollLeft + el.clientWidth >= (el.scrollWidth - 2);
  }

  startAutoScroll(direction: 'left' | 'right') {
    const el = this.scrollArea.nativeElement;

    this.intervalId = setInterval(() => {
      if (direction === 'left') el.scrollLeft -= 15;
      else el.scrollLeft += 15;

      this.onScroll();
    }, 16); // ~60fps
  }

  stopAutoScroll() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
